import { createFileRoute } from '@tanstack/react-router';
import { MyLeavePage } from '@/features/leave/my-leave-page';
import { guardRoute } from '@/lib/route-guards';

/** `/me/leave` (FR-LEAVE-8): my balances and requests. */
export const Route = createFileRoute('/_app/me_/leave')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/me/leave');
  },
  component: MyLeavePage,
});
